import { setAuthSessionItem } from "utils/authSession";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import backgroundImage from "assets/images/bg-profile.jpg";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useCallback, useEffect, useRef, useState } from "react";

import Auto from "components/AutoComplete/AutoComplete";
import MDButton from "components/MDButton";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import MuiPhoneNumber from "material-ui-phone-number";
import Cropper from "react-easy-crop";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCustomerProfileByID, updateCustomerByID } from "utils/api";
import {
  generateDataList,
  handleStreetAddress,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../../components/LoadingModel/loadingModal";

const cropContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: "80px",
};
const controls = {
  position: "absolute",
  bottom: "20px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  justifyContent: "Space-between",
  background: "black",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let id = undefined;
let fetchedUserProfile = {};
let myfile;
let Name;
let LOGIN_DETAILS;
function EditCustomeerProfile({ children }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  let mandateFlag = false;

  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [errorName, setErrorName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErrErr] = useState(false);
  const [mobileNumberErr, setMobileNumberErr] = useState(false);
  const [pNumberErrMsg, setpNumberErrMsg] = useState("");
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);

  const [fileErr, setFileErr] = useState(false);
  const [actualFile, setActualFile] = useState();
  const [fileName, setFileName] = useState("");
  const [imgSupportingText, setImgSupportingText] = useState("");
  const [passwordChecked, setPasswordChecked] = useState(false);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [mobileotp, setOtp] = useState();
  const [newPasswordErr, setNewPasswordErr] = useState(false);
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [newPasswordErrMsg, setNewPasswordErrMsg] = useState("");
  const [confirmPasswordErrMsg, setConfirmPasswordErrMsg] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // ==============For Crop Image Start==============
  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [file1, setFile1] = useState();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(6);
  const [loading, setLoading] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [file, setFile] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [hide, sethide] = useState(false);
  const [state, setState] = useState([]);
  const [country, setCountry] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let countryData = useSelector(
    (state) => state.countryState.countryStateMenu.country
  );
  let stateData = useSelector(
    (state) => state.countryState.countryStateMenu.state
  );

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCropedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(file1, croppedAreaPixels);
      setActualFile(croppedImage);

      //added
      setFile(croppedImage);
      myfile = await fetch(croppedImage)
        .then((r) => r.blob())
        .then(
          (blobFile) =>
            new File([blobFile], actualFile.name, { type: "image/png" })
        );
      setFileName(actualFile.name);
      //

      setOpenCropImageModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "+61",
    onlyPhoneNumber: "",
    zipCode: "",
    city: "",
    stateId: "",
    countryId: "",
    streetAddress: "",
    companyName: "",
    // userPassword: '',
    _id: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (name) => (event) => {
    if (event.target.validity.valid) {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: event.target.value,
      }));
    }
  };

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  id = LOGIN_DETAILS._id;

  useEffect(() => {
    (async () => {
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
    })();
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      values._id = id;
      values.customerID = id;
      getCustomerProfileByID(
        values,
        (data) => {
          if (data.Result_Status) {
            setValues(data.Result_Output[0]);
          }
        },
        dispatch
      );
    }
  }, []);

  Name = values.firstName + " " + values.lastName;

  const clearErrState = () => {
    setFirstNameErr(false);
    setLastNameErrErr(false);
    setStreetAddressErr(false);
  };
  const updateUserProfile = async () => {
    mandateFlag = false;
    clearErrState();
    mandateFlag =
      validateField(values.firstName, setFirstNameErr) || mandateFlag;
    mandateFlag =
      validateField(values.lastName, setLastNameErrErr) || mandateFlag;

    if (values.phoneNumber.toString().trim() === "") {
      setMobileNumberErr(true);
      setpNumberErrMsg("Mobile Number can't be Blank.");
      mandateFlag = true;
    } else if (values.phoneNumber.toString().length <= 10) {
      setpNumberErrMsg("Mobile Number is invalid.");
      setMobileNumberErr(true);
      mandateFlag = true;
    } else setMobileNumberErr(false);

    if (values.userType !== "Admin") {
      mandateFlag =
        validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    }

    if (showPassword) {
      if (values.newPassword === "" || values.newPassword === undefined) {
        setNewPasswordErr(true);
        setShowPassword(true);
        setNewPasswordErrMsg("New Password can't be blank");
        mandateFlag = true;
      } else if (values.newPassword.toString().trim().length < 8) {
        setNewPasswordErr(true);
        setNewPasswordErrMsg(
          "New Password should contain at least 8 characters"
        );
        mandateFlag = true;
      } else setNewPasswordErr(false);

      if (
        values.confirmPassword === "" ||
        values.confirmPassword === undefined
      ) {
        setConfirmPasswordErr(true);
        setConfirmPasswordErrMsg("Confirm Password can't be blank");
        mandateFlag = true;
      } else if (
        values.newPassword.toString().trim() !==
        values.confirmPassword.toString().trim()
      ) {
        setConfirmPasswordErr(true);
        setConfirmPasswordErrMsg(
          "Confirm Password should be same as New Password"
        );
        mandateFlag = true;
      } else setConfirmPasswordErr(false);
    }

    if (mandateFlag) {
      return;
    }
    updateCustomerByID(
      values,
      (data) => {
        if (data.Result_Status) {
          let userDetails = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
          if (userDetails) {
            userDetails.firstName = values.firstName;
            userDetails.lastName = values.lastName;
            setAuthSessionItem(
              "LOGIN_DETAILS",
              JSON.stringify(userDetails)
            );
          }
        }
        showResMsg(
          data.Result_Status ? genericMessage.updated : data.Result_Messagwe,
          1000,
          data.Result_Status,
          navigate,
          "/CusProfile"
        );
      },
      dispatch
    );
  };

  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.countryCode = "+" + country.dialCode;
    values.phoneNumber = values.countryCode + values.phoneNumber;
  };

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        city: "",
        countryId: "",
        streetAddress: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox position="relative" mb={5}>
          <MDBox
            display="flex"
            alignItems="center"
            position="relative"
            minHeight="18.75rem"
            borderRadius="xl"
            sx={{
              backgroundImage: ({
                functions: { rgba, linearGradient },
                palette: { gradients },
              }) =>
                `${linearGradient(
                  rgba(gradients.info.main, 0.6),
                  rgba(gradients.info.state, 0.6)
                )}, url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "50%",
              overflow: "hidden",
            }}
          />
          <Card
            sx={{
              position: "relative",
              mt: -8,
              mx: 3,
              py: 5,
              px: 5,
            }}
          >
            <Grid container columnSpacing={4} rowSpacing={2}>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="text"
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  value={values.firstName}
                  onChange={handleChange("firstName")}
                />
                {firstNameErr ? (
                  <span style={errMsg}>First Name can't be blank</span>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="text"
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  value={values.lastName}
                  onChange={handleChange("lastName")}
                />
                {lastNameErr ? (
                  <span style={errMsg}>Last Name can't be blank</span>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  type="email"
                  label="Username(Email Address)"
                  variant="outlined"
                  fullWidth
                  value={values.emailAddress}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MuiPhoneNumber
                  defaultCountry={"us"}
                  type="text"
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  value={values.phoneNumber}
                  onChange={(phone, country) => setPhoneValues(phone, country)}
                />
                {mobileNumberErr ? (
                  <span style={errMsg}>{pNumberErrMsg}</span>
                ) : (
                  ""
                )}
              </Grid>

              {!hide && (
                <>
                  <Grid item xs={12} md={6} lg={3}>
                    <Auto
                      onChange={handleStreetOnChange}
                      onPlaceSelected={(place, e) =>
                        handleStreetAddress(
                          place,
                          e,
                          (data) => {
                            setValues((prevValues) => ({
                              ...prevValues,
                              zipCode: data.zipCode,
                              city: data.city,
                              countryId: data.countryId,
                              stateId: data.stateId,
                              streetAddress: data.streetAddress,
                            }));
                          },
                          stateListRef,
                          countryListRef
                        )
                      }
                      value={values.streetAddress}
                    />

                    {streetAddressErr ? (
                      <span style={errMsg}>Street Address can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="City"
                      variant="outlined"
                      fullWidth
                      disabled
                      value={values.city}
                      onChange={handleChange("city")}
                    />
                    {cityErr ? (
                      <span style={errMsg}>City can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Zip Code"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        pattern: "^[0-9]+$",
                        maxLength: 4,
                      }}
                      value={values.zipCode}
                      onChange={handleChange("zipCode")}
                    />
                    {zipCodeErr !== "" ? (
                      <span style={errMsg}>{zipCodeErr}</span>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Country
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ minHeight: "44.11px" }}
                        label="Country"
                        disabled
                        value={values.countryId}
                        onChange={(e) =>
                          setValues({ ...values, countryId: e.target.value })
                        }
                      >
                        {country}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox mb={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          State
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "44.11px" }}
                          label="State"
                          disabled
                          value={values.stateId}
                          onChange={(e) =>
                            setValues({ ...values, stateId: e.target.value })
                          }
                        >
                          {state}
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                </>
              )}

              {!showPassword && (
                <Grid item xs={12} md={6} lg={3}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={setShowPassword}
                          // {resetPasswordChecked}
                        />
                      }
                      label="Change Password"
                    />
                  </FormGroup>
                </Grid>
              )}
              {showPassword && (
                <>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        New Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showNewPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              {showNewPassword ? (
                                <VisibilityOff
                                  onClick={() =>
                                    setShowNewPassword(!showNewPassword)
                                  }
                                />
                              ) : (
                                <Visibility
                                  onClick={() =>
                                    setShowNewPassword(!showNewPassword)
                                  }
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        value={values.newPassword}
                        onChange={handleChange("newPassword")}
                        label="New Password"
                      />
                      {newPasswordErr ? (
                        <span style={errMsg}>{newPasswordErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Confirm Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showConfirmPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                />
                              ) : (
                                <Visibility
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Confirm Password"
                        value={values.confirmPassword}
                        onChange={handleChange("confirmPassword")}
                      />
                      {confirmPasswordErr ? (
                        <span style={errMsg}>{confirmPasswordErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid
              container
              mt={2}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
              rowSpacing={2}
            >
              <Grid item xs={12} md={4} spacing={2} lg={1.3}>
                <Link to={"/CusProfile"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                  >
                    Cancel
                  </MDButton>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.3}>
                <MDButton
                  onClick={updateUserProfile}
                  rel="noreferrer"
                  variant="gradient"
                  color="success"
                  fullWidth
                >
                  Save
                </MDButton>
              </Grid>
            </Grid>
          </Card>

          <Modal
            open={openCropImageModal}
            // onClose={props.closeModalClick}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={style}
          >
            <Grid item xs={6} id="modal-modal-title">
              <MDBox style={cropContainer}>
                <Cropper
                  image={file1}
                  crop={crop}
                  zoom={zoom}
                  aspect={4 / 4}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                  cropShape="round"
                />
              </MDBox>
              <MDBox className="row" style={controls}>
                <div className="col-lg-4 col-sm-4">
                  <Typography type="label" size={14} style={{ color: "white" }}>
                    Zoom
                  </Typography>{" "}
                  &nbsp;
                  <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={11}
                    step={1}
                    aria-labelledby="Zoom"
                    onChange={(e) => {
                      setZoom(e.target.value);
                    }}
                    className="zoom-range"
                  />
                </div>
                <div className="col-lg-4 col-sm-4">
                  <Button
                    className="modal-btn action-btn btn-success"
                    onClick={saveCropedImage}
                  >
                    Crop Image
                  </Button>
                </div>
              </MDBox>
            </Grid>
          </Modal>
        </MDBox>
        <LoadingModal loading={loading} />
      </DashboardLayout>
    </>
  );
}

// Setting default props for the Header

export default EditCustomeerProfile;
